module.exports = __webpack_public_path__ + "img/sidebar_bundesliga_202627.286d008a.png";